export default __webpack_public_path__ + "locales/zh-CN/Settings.json?hash=fd06785d40077861e375c0884a7cb2ef";